<template>
  <div v-if="isLoading" class="loading-layout">
    <div class="loading-spinner">
      <div class="spinner medium" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="88">
        <div class="spinner-dot a"></div>
        <div class="spinner-dot b"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "Loading",
  computed: {
    ...mapState({
      isLoading: state => state.General.isLoading
    })
  }
}
</script>

<style scoped lang="scss">
.loading-layout {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.6);
  z-index: 500;
}
.spinner {
  position: absolute;
  z-index: 10;
  width: 2.75rem;
  height: 0;
  transform: translate(-50%, -50%) rotate(90deg);
  transform-origin: 50% 50%;
  top: 50%;
  left: 50%;
}
.loading-spinner {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-backface-visibility: hidden;
  -webkit-animation: ngdialog-fadein 0.5s;
  animation: ngdialog-fadein 0.5s;
  z-index: 9000;
  background: rgba(255,255,255,0.5);
}
.spinner::before {
  position: absolute;
  content: '';
  border-radius: 50%;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-delay: -83.33333ms;
  width: 0.55rem;
  height: 0.55rem;
  background: var(--theme-color-one);
}
.spinner::after {
  position: absolute;
  content: '';
  border-radius: 50%;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-delay: 416.66667ms;
  width: 0.55rem;
  height: 0.55rem;
  background: var(--theme-color-one);
}
.spinner.medium::before {
  animation-name: dotsBounceBefore-medium;
  top: -0.25rem;
  left: -0.25rem;
}
.spinner.medium::after {
  animation-name: dotsBounceAfter-medium;
  top: -0.25rem;
  right: -0.25rem;
}
.spinner-dot {
  position: absolute;
  top: 0;
  left: 0;
  width: 2rem;
  transform-origin: 50% 50%;
}
.spinner-dot::before {
  position: absolute;
  content: '';
  border-radius: 50%;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-name: dotsBounceBefore-medium;
  width: 0.55rem;
  height: 0.55rem;
  background: var(--theme-color-one);
}
.spinner-dot::after {
  position: absolute;
  content: '';
  border-radius: 50%;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-name: dotsBounceAfter-medium;
  width: 0.55rem;
  height: 0.55rem;
  background: var(--theme-color-one);
}
.spinner-dot.a {
  transform: rotate(60deg) translateY(0);
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.spinner-dot.a::before {
  animation-delay: 83.33333ms;
  top: -0.25rem;
  left: -0.25rem;
}
.spinner-dot.a::after {
  animation-delay: 583.33333ms;
  top: -0.25rem;
  right: -0.25rem;
}
.spinner-dot.b {
  transform: rotate(120deg) translateY(0);
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.spinner-dot.b::before {
  animation-delay: 250ms;
  top: -0.25rem;
  left: -0.25rem;
}
.spinner-dot.b::after {
  animation-delay: 750ms;
  top: -0.25rem;
  right: -0.25rem;
}
@keyframes dotsBounceBefore-medium {
  60% {
    transform: translateX(0);
    animation-timing-function: cubic-bezier(0.55, 0.085, 0.68, 0.53);
  }
  80% {
    animation-timing-function: cubic-bezier(0, 1.11, 0.7, 1.43);
    transform: translateX(-0.5rem);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes dotsBounceAfter-medium {
  60% {
    animation-timing-function: cubic-bezier(0.55, 0.085, 0.68, 0.53);
    transform: translateX(0);
  }
  80% {
    animation-timing-function: cubic-bezier(0, 1.11, 0.7, 1.43);
    transform: translateX(0.5rem);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes dotsBounceBefore-small {
  60% {
    transform: translateX(0);
    animation-timing-function: cubic-bezier(0.55, 0.085, 0.68, 0.53);
  }
  80% {
    animation-timing-function: cubic-bezier(0, 1.11, 0.7, 1.43);
    transform: translateX(-0.375rem);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes dotsBounceAfter-small {
  60% {
    animation-timing-function: cubic-bezier(0.55, 0.085, 0.68, 0.53);
    transform: translateX(0);
  }
  80% {
    animation-timing-function: cubic-bezier(0, 1.11, 0.7, 1.43);
    transform: translateX(0.375rem);
  }
  100% {
    transform: translateX(0);
  }
}

</style>